import { __assign } from "tslib";
import _GalleryOptions from './ProGallery.options.json';
import _GallerySections from './ProGallery.sectionOptions.json';
// @ts-ignore
delete _GalleryOptions.$schema;
// @ts-ignore
delete _GallerySections.$schema;
export var ProGalleryOptions = _GalleryOptions;
export var ProGallerySettingsOptions = __assign(__assign({}, ProGalleryOptions), _GallerySections);
export var processProGalleryOptions = function (options) { return (__assign(__assign({}, Object.values(ProGalleryOptions).reduce(function (defaults, option) {
    var _a;
    return (__assign(__assign({}, defaults), (_a = {}, _a[option.key] = option.default, _a)));
}, {})), options)); };
//# sourceMappingURL=ProGallery.options.js.map